import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';
import type { CardProps } from './card.types';

const cardVariants = cva('rounded-lg transition-shadow', {
    variants: {
        variant: {
            elevated: 'bg-[var(--color-neutral-0)] shadow-md hover:shadow-lg',
            outlined: 'bg-[var(--color-neutral-0)] border border-[var(--color-neutral-20)]',
            filled: 'bg-[var(--color-neutral-10)]',
        },
        padding: {
            none: 'p-0',
            small: 'p-3',
            medium: 'p-4',
            large: 'p-6',
        },
        pressable: {
            true: 'cursor-pointer hover:scale-[1.02] active:scale-[0.98]',
            false: '',
        },
    },
    defaultVariants: {
        variant: 'elevated',
        padding: 'medium',
        pressable: false,
    },
});

const Card: React.FC<CardProps> = ({
    variant = 'elevated',
    pressable = false,
    padding = 'medium',
    onPress,
    children,
    className,
    onClick,
    ...props
}) => {
    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        onClick?.(e);
        onPress?.();
    };

    return (
        <div
            data-testid="card"
            className={cn(cardVariants({ variant, padding, pressable: pressable || !!onPress }), className)}
            onClick={pressable || onPress ? handleClick : onClick}
            role={pressable || onPress ? 'button' : undefined}
            tabIndex={pressable || onPress ? 0 : undefined}
            {...props}
        >
            {children}
        </div>
    );
};

export default Card;
